import { render, staticRenderFns } from "./salesGroup.vue?vue&type=template&id=4a7fc458&scoped=true"
import script from "./salesGroup.vue?vue&type=script&lang=js"
export * from "./salesGroup.vue?vue&type=script&lang=js"
import style0 from "./salesGroup.vue?vue&type=style&index=0&id=4a7fc458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7fc458",
  null
  
)

export default component.exports